module.exports = __webpack_public_path__ + "img/c92936cac63b23b854f0294239be0cf8.png";